/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FiEyeOff, FiEye } from "react-icons/fi";
import * as S from "../../styles";

export interface IPasswordInputProps {
    id: string;
    label?: string;
    value?: string;
    errorText?: string;
    required?: boolean;
    readOnly?: boolean;
    placeholder?: string;
    labelColor?: string;
    hasError?: boolean;
    onCompChange?(id: string, payload: any): void;
}

export const PasswordInput = ({
    id,
    label,
    errorText,
    value,
    required,
    placeholder,
    onCompChange,
    labelColor,
    readOnly,
    hasError
}: IPasswordInputProps) => {
    const [textValue, setTextValue] = useState(value ?? "");
    const [passwordType, setPasswordType] = useState("password");
    const [isInvalid, setInvalid] = useState(false);

    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
    }, [hasError]);
    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
            return;
        }
        setPasswordType("password");
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className="mb-4 formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <Form.Control
                        className="formcontrol shadow-none"
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={required}
                        type={passwordType}
                        placeholder={placeholder}
                        readOnly={readOnly}
                        isInvalid={isInvalid}
                    />
                    <InputGroup.Text
                        style={{ border: "none", cursor: "pointer" }}
                        onClick={togglePassword}
                    >
                        {passwordType === "password" ? (
                            <FiEyeOff size={15} />
                        ) : (
                            <FiEye size={15} />
                        )}
                    </InputGroup.Text>
                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

PasswordInput.defaultProps = {
    required: false,
    readOnly: false,
    hasError: false
};
